import { useState } from 'react';
import { IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';
import { RoleRequest } from 'components/RoleRequest';
import { MobileTooltip } from 'components/MobileTooltip';
import { selfName } from './constants';

export interface Props {
  name: string;
  multiple?: boolean;
}

function displayName(name: string, multiple?: boolean) {
  const roleOrRoles = multiple ? 'Roles' : 'Role';
  if (name === selfName) return `My ${roleOrRoles}`;
  if (!name) return `${roleOrRoles}`;
  return `${name}'s ${roleOrRoles}`;
}

export const RoleHeader = ({ name, multiple }: Props) => {
  const [showRoleRequest, setShowRoleRequest] = useState(false);
  return (
    <div className="flex gap-2 items-center mb-2">
      <h6 className="font-semibold text-xl">
        {displayName(name, multiple)}
      </h6>
      <span className="italic">(required)</span>
      <MobileTooltip title="Click to request role" placement="top">
        <IconButton color="inherit" onClick={() => setShowRoleRequest((p) => !p)}>
          <Info color="secondary" />
        </IconButton>
      </MobileTooltip>
      {showRoleRequest && <RoleRequest />}
    </div>
  );
};
